import { useExpiringValue } from "@outschool/ui-utils";

const FEED_EXPIRATION_MS = 60 * 60 * 1000;

export function useParentDashboardSeed() {
  const [seed] = useExpiringValue(
    "mobile parent dashboard seed",
    Math.floor(10000 * Math.random()),
    FEED_EXPIRATION_MS
  );
  return seed;
}
